/**
 * DevExtreme (esm/__internal/ui/collection/hierarchical.js)
 * Version: 24.1.8
 * Build date: Mon Dec 16 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import HierarchicalCollectionWidget from "../../../ui/hierarchical_collection/ui.hierarchical_collection_widget";
import CollectionWidgetEdit from "./edit";
const TypedCollectionWidget = HierarchicalCollectionWidget;
export default TypedCollectionWidget;
